import { TOrderInfoKeyword } from "@/entities/new-order";

export const getDateListFromOrderKeywords = (keywords: TOrderInfoKeyword[]) => {
  //ТОЛЬКО ДЛЯ ПАРСИНГА С СЕРВЕРА
  const newDateArray: string[] = [];
  keywords.forEach((keyword) => {
    if (!newDateArray.find((date) => date === keyword.date)) {
      newDateArray.push(keyword.date);
    }
  });
  return newDateArray;
};
